import ProgramActionTypes from "./ProgramsActionType";

const INITIAL_STATE = {
  tab: null,
};

const programsReducer = (state = INITIAL_STATE, action = { type: "" }) => {
  switch (action.type) {
    case ProgramActionTypes.SET_TAB_DATA:
      return {
        ...state,
        tab: action.payload,
      };
    default:
      return state;
  }
};

export default programsReducer;
